// Carry consented list context into the existing native product-view event. No extra event sender.
(() => {
  'use strict';
  if (document.documentElement.dataset.ylProductSelectionBound) return;
  document.documentElement.dataset.ylProductSelectionBound = 'true';
  const lists = new Set(['shop_all', 'home_featured', 'search_results', 'security_guide', 'temperature_guide', 'water_guide']);
  const cardSelector = '.yb-product-card[data-yl-product-id], [data-yl-selection-card][data-yl-product-id]';
  const restorations = new WeakMap();
  let privacyRequested = false;
  function loadPrivacy() {
    try {
      if (privacyRequested || typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' ||
          typeof window.Shopify?.loadFeatures !== 'function') return;
      privacyRequested = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], () => {});
    } catch { /* Missing privacy support leaves context disabled. */ }
  }
  loadPrivacy();
  document.addEventListener('DOMContentLoaded', loadPrivacy, {once: true});

  function activate(event) {
    try {
      if (event.isTrusted === false || event.defaultPrevented ||
          (event.type === 'click' ? event.button !== 0 : event.button !== 1)) return;
      const link = event.target.closest?.('a[href]');
      const card = link?.closest(cardSelector);
      if (!card) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/.test(destination.pathname)) return;
      const original = link.getAttribute('href');
      const stale = destination.searchParams.has('yl_list') || destination.searchParams.has('yl_index');
      destination.searchParams.delete('yl_list');
      destination.searchParams.delete('yl_index');
      const clean = stale ? destination.href : original;
      // A later declined/unknown activation must not inherit previously added context.
      if (stale) link.setAttribute('href', clean);
      const list = card.closest('[data-yl-selection-list]');
      const productId = link.hasAttribute('data-yl-product-id') ? link.dataset.ylProductId : card.dataset.ylProductId;
      if (!list || !lists.has(list.dataset.ylSelectionList) || link.hasAttribute('download') ||
          typeof productId !== 'string' || !/^\d{5,20}$/.test(productId)) return;
      const visible = [...list.querySelectorAll(cardSelector)].filter(item =>
        item.closest('[data-yl-selection-list]') === list && item.getClientRects().length > 0 &&
        getComputedStyle(item).visibility !== 'hidden');
      const index = visible.indexOf(card) + 1;
      if (!index || window.Shopify?.designMode === true ||
          typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' ||
          window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return;
      destination.searchParams.set('yl_list', list.dataset.ylSelectionList);
      destination.searchParams.set('yl_index', String(index));
      const tagged = destination.href, token = {};
      restorations.set(link, token);
      link.setAttribute('href', tagged);
      // The browser follows the link normally. Restore a surviving source-page link after its default action.
      setTimeout(() => {
        if (restorations.get(link) !== token) return;
        restorations.delete(link);
        if (link.getAttribute('href') === tagged) link.setAttribute('href', clean);
      }, 0);
    } catch { /* Context must never interrupt navigation or weaken consent. */ }
  }
  document.addEventListener('click', activate);
  document.addEventListener('auxclick', activate);
})();
